
<bw-spinner *ngIf="!displayList; else selectCompany"></bw-spinner>

<ng-template #selectCompany>
  <bw-action-article [brightsideWebFb]="{ event_name: 'collect_employer' }">
    <div header-title class="mb-sm">
      <typography title-medium>{{ 'SELECT_EMPLOYER_TITLE' | translate }}</typography>
    </div>
    <div content-section>
      <typography text-medium-regular>
        <p class="secondary-text mb-sm">{{ 'SELECT_EMPLOYER_DESC' | translate }}</p>
      </typography>
      <brightside-web-employer-list [showProcessSpinner]="processing" [dataList]="employerList" (listSelected)="onCompanySelected($event)"></brightside-web-employer-list>
    </div>
    <div footer-actions class="flex-row row-reverse"></div>
  </bw-action-article>
  <brightside-web-hr-modal
    *ngIf="showHrModal"
    [title]="hrModalDetails.title | translate"
    [prompt]="hrModalDetails.prompt | translate"
    [brightsideWebFb]="hrModalDetails.brightsideWebFb"
    (dismissed)="onDismiss()"
  >
  </brightside-web-hr-modal>
</ng-template>
